module.exports = __webpack_public_path__ + "img/parttwo_pic1.f567cb09.png";